const PROFILE_FIELDS = [
    "name",
    "web_url",
    "phone_number",
    "email",
    "contract_number",
    "address",
    "translates",
];

export function selectedBusinessTypeIds(form) {
    const raw = Array.isArray(form?.business_types)
        ? form.business_types
        : form?.category != null && form.category !== ""
          ? [form.category]
          : [];
    return raw
        .map((item) => Number(item && item.value != null ? item.value : item))
        .filter((id) => Number.isFinite(id) && id > 0);
}

export function buildCompanyProfilePayload(form, translates) {
    const payload = {};
    const source = { ...form, translates: translates ?? form?.translates };
    for (const key of PROFILE_FIELDS) {
        if (source[key] !== undefined) {
            payload[key] = source[key];
        }
    }
    const businessTypes = selectedBusinessTypeIds(source);
    payload.business_types = businessTypes;
    if (businessTypes.length) {
        payload.category = businessTypes[0];
    } else if (source.category !== undefined) {
        payload.category = source.category || null;
    }
    const logo = source.logo;
    if (logo && String(logo).indexOf("data:image") === 0) {
        payload.logo = logo;
    }
    return payload;
}
